module.exports = __webpack_public_path__ + "static/media/cephalopidoptera.56ddb5e1.jpg";